<template>
  <div class="zcbody" v-loading="loading">
    <div class="zc-header">
      <div class="head">
        <div class="logo"><img src="../../assets/images/logo.png" /></div>
        <span class="logintext">认养一头牛SRM供应商管理平台</span>
      </div>
    </div>
    <div class="contaner">
      <div style="text-align:center;">
        <div class="ribbon" style="margin-top:20px;">
          <a><span><img src="../../assets/images/sy-list1.png">用户信息</span></a>
          <a><span><img src="../../assets/images/sy-list2.png">供货信息</span></a>
          <a class="active"><span><img src="../../assets/images/sy-list3.png">上传资质</span></a>
        </div>
      </div>
      <div class="protocol-title">上传资质文件</div>
      <div class="protocont">
        <span style="color: red" class="prospan">红色字体为必填项，资质上传日期、资质失效日期以及扫描件不能为空</span>

        <el-table ref="multipleTable" :data="tableall" border max-height="560" v-if="tableif" tooltip-effect="dark"
          style="width: 100%" :header-cell-style="{ background: '#eef1f6', textAlign: 'center' }">
          <el-table-column label="资质名称" width="120" :render-header="renderHeader">
            <template slot-scope="scope">
              <font style="color: red" v-if="scope.row.cisupload == '1' ">{{ scope.row.cfilename }}</font>
              <font style="color: #333" v-else>{{ scope.row.cfilename }}</font>
            </template>
          </el-table-column>
          <el-table-column label="资质编号" prop="cfilecode" width="90" :render-header="renderHeader"></el-table-column>
          <el-table-column label="上传时间" width="152" prop="dfileuplodtime"
            :render-header="renderHeader"></el-table-column>
          <el-table-column label="资质生效时间" width="120" prop="dfilestarttime"></el-table-column>
          <el-table-column label="资质失效时间" width="120" prop="dfileendtime"></el-table-column>
          <!-- <el-table-column
            label="文件路径"
            prop="cdemopath"
            :render-header="renderHeader"
          ></el-table-column> -->
          <el-table-column label="备注" prop="cremakspaper"></el-table-column>
          <el-table-column prop="name" label="操作" width="260">
            <template slot-scope="scope">
              <el-button size="mini" @click="regit(scope.row, scope.$index)">添加修改</el-button>
              <el-button size="mini" @click="read(scope.row, scope.$index)" v-if="scope.row.cdemopath!=''"
                plain>查看</el-button>
              <el-button size="mini" type="success" @click="down(scope.row, scope.$index)" v-if="scope.row.cfileurl!=''"
                plain>下载</el-button>
            </template>
          </el-table-column>
        </el-table>
        <div class="prompt-text">
          请上传资质文件原件的扫描件，<span style="color:red">选择类型为PDF文件或者图片</span>，请彩色扫描并上传。要求:
          所有文档均需贵公司签字、盖章（2页的需要盖骑缝章）、标明时间。
        </div>
        <div class="zc_btn">
          <el-button type="success" round @click="prereturn()">上一步</el-button>
          <el-button type="success" round @click="clickSubmit()">保存</el-button>
        </div>
      </div>
      <el-dialog :visible.sync="dialogFormVisible" :append-to-body="true" customClass="way assoform">
        <el-form ref="assoruleForm" :rules="assorules" :model="qualiform" label-width="85px" class="form01"
          v-if="qualiform.cisupload == '1' ">
          <el-row :gutter="20">
            <el-col :span="24">
              <el-form-item label=" 生效日期:" prop="dfilestarttime">
                <el-date-picker v-model="qualiform.dfilestarttime" type="date" key="a" placeholder="选择日期"
                  value-format="yyyy-MM-dd"></el-date-picker>
              </el-form-item>
            </el-col>

            <el-col :span="24">
              <el-form-item label="失效日期:" prop="dfileendtime">
                <el-date-picker v-model="qualiform.dfileendtime" type="date" key="b" placeholder="选择日期"
                  value-format="yyyy-MM-dd"></el-date-picker>
              </el-form-item>
            </el-col>

            <el-col :span="24">
              <el-form-item label="备注:" label-width="100%" style="margin-bottom: 0" class="itemcenter"></el-form-item>
              <el-form-item prop="cremakspaper" label-width="0">
                <el-input type="textarea" v-model="qualiform.cremakspaper" placeholder="请输入备注" rows="4"
                  style="width: 100%"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item prop="cdemopath" label="证书:" class="crem">
                <el-upload action="#" ref="uploadFail" :show-file-list="false" accept=".pdf,.png,.jpg,.jpeg"
                  :before-upload="brforeUploadreImportFail" :auto-upload="false" :on-change="handleChangeFail"
                  :file-list="fileListFail">
                  <el-button type="success" size="mini">上传证书</el-button>
                  <!-- <div slot="tip" class="el-upload__tip">
                  只能上传.pdf/.PDF文件
                </div> -->
                  <div slot="tip" class="el-upload__tip" style="color:green">证书名称:{{ Cname }}</div>
                </el-upload>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
        <el-form ref="assoruleForm" :model="qualiform" label-width="85px" class="form01" v-else>
          <el-row :gutter="20">
            <el-col :span="24">
              <el-form-item label=" 生效日期:" prop="dfilestarttime">
                <el-date-picker v-model="qualiform.dfilestarttime" type="date" key="a" placeholder="选择日期"
                  value-format="yyyy-MM-dd"></el-date-picker>
              </el-form-item>
            </el-col>

            <el-col :span="24">
              <el-form-item label="失效日期:" prop="dfileendtime">
                <el-date-picker v-model="qualiform.dfileendtime" type="date" key="b" placeholder="选择日期"
                  value-format="yyyy-MM-dd"></el-date-picker>
              </el-form-item>
            </el-col>

            <el-col :span="24">
              <el-form-item label="备注:" label-width="100%" style="margin-bottom: 0" class="itemcenter"></el-form-item>
              <el-form-item prop="cremakspaper" label-width="0">
                <el-input type="textarea" v-model="qualiform.cremakspaper" placeholder="请输入备注" rows="4"
                  style="width: 100%"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item prop="cdemopath" label="证书:" class="crem">
                <el-upload action="#" ref="uploadFail" :show-file-list="false" :before-upload="brforeUploadreImportFail"
                  :auto-upload="false" :on-change="handleChangeFail" :file-list="fileListFail">
                  <el-button type="success" size="mini">上传证书</el-button>
                  <!-- <div slot="tip" class="el-upload__tip">
                  只能上传.pdf/.PDF文件
                </div> -->
                  <div slot="tip" class="el-upload__tip">证书名称:{{ Cname }}</div>
                </el-upload>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click="closesad()">取 消</el-button>
          <el-button type="success" @click="confirm('assoruleForm')">确 定</el-button>
        </div>
      </el-dialog>
    </div>
  </div>
</template>

<script>
  export default {
    data() {
      return {
        qualiform: {
          dfilestarttime: "",
          dfileendtime: "",
          cremakspaper: "",
          cdemopath: "",
        },
        loading: false,
        urlid: "",
        tableall: [],
        dialogFormVisible: false,
        //文件名字
        fileList: [],
        //文件名字
        fileListFail: [],
        assorules: {
          cdemopath: [{ required: true, message: "请上传文件", trigger: "blur" }],
          dfilestarttime: [
            { required: true, message: "请资质生效日期", trigger: "blur" },
          ],
          dfileendtime: [
            { required: true, message: "请资质失效日期", trigger: "blur" },
          ],
        },
        Cname: "",
        tableif: true,
        infouser: {
          row1: [],
          row2: [],
          row3: [],
          data1: [],
          data2: [],
          newdata: [],
        },
      };
    },
    created() {
      if (JSON.parse(window.localStorage.getItem("userdata"))) {
        this.urlid = JSON.parse(window.localStorage.getItem("userdata")).id;
        this.getTableData();
      } else {
        this.$message.error("您还没有登录，请登录");
        setTimeout(() => {
          this.$router.push({ name: "login" });
        }, 1000);
      }
    },
    methods: {
      down(row, afff) {
        if (row.cfileurl != "") {
          // 下载文件
          //  let routeUrl = row.cfileurl;
          // window.open(routeUrl);
          const a = document.createElement("a");
          let urlblob = this.global.bxiosdow + row.cfileurl;
          fetch(urlblob)
            .then((res) => res.blob())
            .then((blob) => {
              // 将链接地址字符内容转变成blob地址
              a.href = URL.createObjectURL(blob);
              console.log(a.href);
              a.download = ""; // 下载文件的名字
              document.body.appendChild(a);
              a.click();
            });
        } else {
          this.$message.error("暂无文件");
        }
      },
      // 判断刷新
      listenPage() {
        window.onbeforeunload = function (e) {
          e = e || window.event;
          if (e) {
            console.log("5464");
            sessionStorage.removeItem("tableall");
            e.returnValue = "关闭提示";
          }
          return "关闭提示";
        };
      },
      // 获取基本信息
      getTableData() {
        console.log(sessionStorage.getItem("tableall"));
        if (sessionStorage.getItem("tableall") != null) {
          this.tableall = JSON.parse(sessionStorage.getItem("tableall"));
        } else {
          this.$axios({
            method: "post",
            url: "CommonModule/Op_Supplier/GetCustomerFile",
            data: { KeyValue: this.urlid },
          }).then((res) => {
            console.log(res, "urlid");
            if (res.data.Success) {
              if (res.data.Data != "") {
                this.tableall = res.data.Data;
              }
            } else {
              this.$message.error(res.data.Message);
            }
          });
        }
      },
      // 查看
      read(row, index) {
        let routeUrl = this.global.BASE_URL + row.cdemopath;
        window.open(routeUrl);
      },
      //上传文件
      handleChangeFail(file, fileList) {
        this.$refs.uploadFail.submit();
      },

      brforeUploadreImportFail(file) {
        this.loading = true;
        let params = new FormData();
        params.append("KeyValue", this.urlid);
        params.append("file", file);
        params.append("file", URL.createObjectURL(file));
        params.append("dindex", this.qualiform.dindex);
        console.log(file, "开始上传");
        this.$axios({
          method: "post",
          url: "CommonModule/Op_Supplier/SaveCusPaper",
          headers: { "Content-Type": "multipart/form-data" },
          data: params,
          timeout: 30000000,
        }).then((res) => {
          console.log(res, "上传结果");
          this.loading = false;
          if (res.data.Success) {
            this.$message({
              howClose: true,
              message: "上传成功",
              type: "success",
            });

            this.qualiform.cdemopath = res.data.Data.Path;
            this.Cname = res.data.Data.Cname;
            this.qualiform.dfileuplodtime = res.data.Data.CreateTime;
          } else {
            this.Cname = res.data.Message;
          }
        });

        return false; //屏蔽了action的默认上传
      },

      closesad(assoruleForm) {
        (this.qualiform = {
          dfilestarttime: "",
          dfileendtime: "",
          cremakspaper: "",
          cdemopath: "",
        }),
          (this.Cname = "");
        this.dialogFormVisible = false;
      },
      confirm(assoruleForm) {
        this.$refs[assoruleForm].validate((valid) => {
          if (valid) {
            this.tableif = false;
            console.log(this.qualiform);
            for (var a = 0; a < this.tableall.length; a++) {
              if (this.qualiform.cfilecode == this.tableall[a].cfilecode) {
                this.tableall[a] = this.qualiform;
              }
            }
            setTimeout(() => {
              this.tableif = true;
            }, 3);

            console.log(this.tableall);
            this.Cname = "";
            this.dialogFormVisible = false;
          } else {
            this.$message.error("请填写完整信息");
            return false;
          }
        });
      },
      // 添加和修改
      regit(row, index) {
        this.qualiform = JSON.parse(JSON.stringify(row));
        this.Cname = this.qualiform.cdemopath.split("/")[3];
        this.dialogFormVisible = true;
        setTimeout(() => {
          this.$refs.assoruleForm.resetFields();
          console.log(this.$refs.assoruleForm);
        }, 100);
      },
      renderHeader(h, { column }) {
        return h("div", [
          h(
            "font",
            {
              style: "color:red;margin-right:5px;",
            },
            "*"
          ),
          h(
            "span",
            {
              style: "color:#046dbe;",
            },
            column.label
          ),
        ]);
      },

      // 返回上一步
      prereturn() {
        this.$router.push({ path: "/UserCenterWareinfo" });
      },
      // 提交保存
      clickSubmit() {
        console.log(sessionStorage.getItem("infoJson"));
        if (sessionStorage.getItem("infoJson") != null) {
          this.infouser.row1 = [JSON.parse(sessionStorage.getItem("infoJson"))];
          this.infouser.row2 = JSON.parse(sessionStorage.getItem("sdatable"));
          this.infouser.row3 = JSON.parse(sessionStorage.getItem("assotbale"));
          this.infouser.row4 = JSON.parse(sessionStorage.getItem("anlitable"));
          this.alldata1();
        } else if (sessionStorage.getItem("infoJson") == null) {
          this.$axios({
            method: "post",
            url: "CommonModule/Op_Supplier/GetVendorInfos",
            data: { KeyValue: this.urlid },
          }).then((res) => {
            this.loading = false;
            console.log(res);
            if (res.data.Success) {
              if (res.data.Message) {
                this.$message.error(res.data.Message);
              }
              if (res.data.Data != "") {
                if (res.data.Data.row1.length != 0) {
                  this.infouser.row1 = res.data.Data.rows1;
                  this.infouser.row2 = res.data.Data.rows2;
                  this.infouser.row3 = res.data.Data.rows3;
                  this.infouser.row4 = res.data.Data.rows4;
                  this.alldata1();
                }
              }
            } else {
              this.$message.error(res.data.Message);
            }
          });
        }
      },
      alldata1() {
        if (sessionStorage.getItem("jsondata") != null) {
          this.infouser.data2 = JSON.parse(sessionStorage.getItem("jsondata"));
          this.infouser.data1 = JSON.parse(
            sessionStorage.getItem("suppliestable")
          );
          this.endsubmit();
        } else if (sessionStorage.getItem("jsondata") == null) {
          this.$axios({
            method: "post",
            url: "CommonModule/Op_Supplier/GetCusInvClass",
            data: { KeyValue: this.urlid },
          }).then((res) => {
            console.log(res, "urlid");
            if (res.data.Success) {
              this.infouser.data1 = res.data.Data.data1;
              this.infouser.data2 = res.data.Data.data2;
              this.endsubmit();
            } else {
              this.$message.error(res.data.Message);
            }
          });
        }
      },
      endsubmit() {
        var ddd = this.tableall;
        var newdata = [];
        for (var i = 0; i < ddd.length; i++) {
          console.log(ddd[i].cdemopath);
          // if (ddd[i].cdemopath == "") {
          //   //判断前五条图片地址是否为空
          //   this.$message.error("信息不完整！");
          //   return;
          // } else
          if (ddd[i].cfilecode == "") {
            //判断前五条图片地址是否为空
            this.$message.error("资质编号为空！");
            return;
          } else {
            newdata.push({
              cfilecode: ddd[i].cfilecode,
              dfileuplodtime: ddd[i].dfileuplodtime,
              dfilestarttime: ddd[i].dfilestarttime,
              dfileendtime: ddd[i].dfileendtime,
              cremakspaper: ddd[i].cremakspaper,
              cdemopath: ddd[i].cdemopath,
              cfilename: ddd[i].cfilename,
              // dindex:ddd[i].dindex
            });
          }
        }

        this.infouser.newdata = newdata;
        console.log(this.infouser);
        this.$axios({
          method: "post",
          url: "CommonModule/Op_Supplier/UpdateCustomer",
          data: {
            JsonInfo: JSON.stringify(this.infouser),
            KeyValue: this.urlid,
            ticket: window.localStorage.getItem("token"),
          },
        }).then((res) => {
          console.log(res, "urlid");

          if (res.data.Success) {
            this.$message.success(res.data.Message);
          } else {
            this.$message.error(res.data.Message);
          }
        });
      },
    },
    mounted() {
      this.listenPage();
    },
  };
</script>
<style scoped>
  @import url(../../assets/css/reg.css);

  .crem>>>.el-form-item__label {
    background: none;
    border: 0;
  }
</style>